/** Frosted-glass AmCharts tooltip shell — matches PanelChangeDetailPanel. */
export const getChartBalloonShellStyles = theme => {
  const isDark = theme.palette.type === 'dark';
  const glassBackground = isDark ? 'rgba(0,0,0,0.65)' : 'rgba(255,255,255,0.65)';
  const stickyBackground = isDark ? 'rgba(0,0,0,0.85)' : 'rgba(255,255,255,0.85)';

  return {
    glassBackground,
    stickyBackground,
    shell: [
      'border-radius: 4px',
      'padding: 8px',
      `background: ${glassBackground}`,
      'backdrop-filter: blur(12px)',
      '-webkit-backdrop-filter: blur(12px)',
      `border: 1px solid ${theme.palette.divider}`,
      `box-shadow: ${theme.shadows[8]}`,
      `color: ${theme.palette.text.primary}`,
      'font-family: Inter, sans-serif',
      'font-size: 13px',
      'line-height: 15px',
      '-webkit-font-smoothing: auto',
      'user-select: none',
      'margin-top: 7px',
    ].join('; '),
    table:
      'width:100%; border: none!important; border-collapse: collapse; background: transparent; color: inherit; text-align: left;',
    headerRow: `font-weight: bold; font-size: 11px; color: ${theme.palette.text.secondary};`,
    stickyRow: `font-weight: bold; font-size: 11px; position: sticky; top: 0; z-index: 1; background: ${stickyBackground}; backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px); color: ${theme.palette.text.secondary};`,
    metricDivider: `box-shadow: 0 1px 0 0 ${theme.palette.divider}; z-index: 1;`,
  };
};
